export default __webpack_public_path__ + "static/media/StatusCall.d58af000.svg";